// Constantes PURAS do tracker de legalização — zero import, zero efeito.
//
// ⚠️ Por que fora do `hooks/useLegalizacao.ts`: elas moravam lá dentro, junto
// do hook, e o hook importa `services/api` → axios. Qualquer módulo que
// quisesse só o rótulo de um tipo passava a arrastar o cliente HTTP inteiro —
// o que quebra em teste (o axios do node_modules é ESM e o jest do CRA não o
// transforma) e infla o bundle de quem só queria três strings.
//
// O hook segue reexportando tudo daqui, então nada que já importava dele
// precisou mudar.

export type TipoLegalizacao = 'constituicao' | 'alteracao' | 'baixa';

export const TIPOS_LEGALIZACAO: TipoLegalizacao[] = ['constituicao', 'alteracao', 'baixa'];

export const TIPO_LEGALIZACAO_LABEL: Record<TipoLegalizacao, string> = {
  constituicao: 'Constituição',
  alteracao: 'Alteração',
  baixa: 'Baixa',
};
